/**
 * @module modules/commit-detail-picker-sk
 * @description <h2><code>commit-detail-picker-sk</code></h2>
 *
 * @evt commit-selected - Emitted when a commit is selected. The details are of
 * the form CommitDetailPanelSkCommitSelectedDetails
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CommitDetailPickerSk", {
    enumerable: true,
    get: function() {
        return CommitDetailPickerSk;
    }
});
require("../commit-detail-panel-sk");
require("../../../elements-sk/modules/spinner-sk");
require("../day-range-sk");
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _task = require("@lit/task");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _errorMessage = require("../errorMessage");
const _json = require("../json");
const _dayrangesk = require("../day-range-sk/day-range-sk");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
const NO_COMMIT_SELECTED_MSG = 'Choose a commit.';
const initialRange = {
    begin: Math.floor(Date.now() / 1000 - 24 * 60 * 60),
    end: Math.floor(Date.now() / 1000)
};
let CommitDetailPickerSk = class CommitDetailPickerSk extends _lit.LitElement {
    get _title() {
        var _this__commitTask_value;
        const index = this.selected;
        if (index === -1) {
            return NO_COMMIT_SELECTED_MSG;
        }
        const d = (_this__commitTask_value = this._commitTask.value) === null || _this__commitTask_value === void 0 ? void 0 : _this__commitTask_value[index];
        if (!d) {
            return NO_COMMIT_SELECTED_MSG;
        }
        return `${d.author} -  ${d.message}`;
    }
    createRenderRoot() {
        return this;
    }
    render() {
        var _this__commitTask_value;
        return (0, _lit.html)`
      <button @click=${this.open}>${this._title}</button>
      <dialog>
        <h2>Choose a commit</h2>
        <commit-detail-panel-sk
          @commit-selected="${this.panelSelect}"
          .details="${(_this__commitTask_value = this._commitTask.value) !== null && _this__commitTask_value !== void 0 ? _this__commitTask_value : []}"
          selectable
          .selected=${this.selected}></commit-detail-panel-sk>
        <button class="close-dialog" @click=${this.close}>Close</button>

        <hr />
        <p class="tiny">Change the range of commits displayed:</p>
        <details>
          <summary>Date Range</summary>
          <day-range-sk
            id="range"
            @day-range-change=${this.rangeChange}
            .begin=${this.range.begin}
            .end=${this.range.end}></day-range-sk>
          <spinner-sk ?active=${this._commitTask.status === _task.TaskStatus.PENDING}></spinner-sk>
        </details>
      </dialog>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        this._fetchTrigger++;
    }
    rangeChange(e) {
        this.range = e.detail;
        this._fetchTrigger++;
    }
    panelSelect(e) {
        this.selected = e.detail.selected;
        this.close();
    }
    close() {
        this.dialog.close();
    }
    open() {
        this.dialog.showModal();
    }
    constructor(...args){
        super(...args);
        this.range = initialRange;
        this.selection = (0, _json.CommitNumber)(-1);
        this.selected = -1;
        this._fetchTrigger = 0;
        this._commitTask = new _task.Task(this, {
            task: async ([_trigger, _selection_arg])=>{
                try {
                    const body = {
                        begin: this.range.begin,
                        end: this.range.end,
                        offset: this.selection
                    };
                    const resp = await fetch('/_/cidRange/', {
                        method: 'POST',
                        body: JSON.stringify(body),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    const cids = await (0, _jsonOrThrow.jsonOrThrow)(resp);
                    cids.reverse();
                    for(let i = 0; i < cids.length; i++){
                        if (cids[i].offset === this.selection) {
                            this.selected = i;
                            break;
                        }
                    }
                    if (cids.length > 0) {
                        this.range = _object_spread_props(_object_spread({}, this.range), {
                            begin: cids[cids.length - 1].ts,
                            end: cids[0].ts
                        });
                    }
                    return cids;
                } catch (error) {
                    (0, _errorMessage.errorMessage)(error);
                    throw error;
                }
            },
            args: ()=>[
                    this._fetchTrigger,
                    this.selection
                ]
        });
    }
};
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", typeof _dayrangesk.DayRangeSkChangeDetail === "undefined" ? Object : _dayrangesk.DayRangeSkChangeDetail)
], CommitDetailPickerSk.prototype, "range", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    }),
    _ts_metadata("design:type", typeof _json.CommitNumber === "undefined" ? Object : _json.CommitNumber)
], CommitDetailPickerSk.prototype, "selection", void 0);
_ts_decorate([
    (0, _decorators.state)(),
    _ts_metadata("design:type", Number)
], CommitDetailPickerSk.prototype, "selected", void 0);
_ts_decorate([
    (0, _decorators.state)()
], CommitDetailPickerSk.prototype, "_fetchTrigger", void 0);
_ts_decorate([
    (0, _decorators.query)('dialog'),
    _ts_metadata("design:type", typeof HTMLDialogElement === "undefined" ? Object : HTMLDialogElement)
], CommitDetailPickerSk.prototype, "dialog", void 0);
CommitDetailPickerSk = _ts_decorate([
    (0, _decorators.customElement)('commit-detail-picker-sk')
], CommitDetailPickerSk);
